import { Component, OnInit } from '@angular/core';
import { Store } from '@ngxs/store';
import { AuthState } from '@app/store/auth/auth.state';

@Component({
  selector: 'app-stock-entry',
  templateUrl: './stock-entry.component.html',
  styleUrls: ['./stock-entry.component.sass'],
})
export class StockEntryComponent implements OnInit {
  buttonsTvf: any[] = [];

  private readonly allButtons = [
    {
      icon: 'local_shipping',
      label: 'INICIAR RECEBIMENTO',
      color: '#FF6600',
      route: '/tvf/recebimento/lotes',
      flags: ['ORCV', 'OCL'],
    },
    {
      icon: 'assignment_turned_in',
      label: 'ROMANEIO DE RECEBIMENTO',
      color: '#003B71',
      route: '/tvf/recebimento/receber',
      flags: ['ORCV'],
    },
    {
      icon: 'collections_bookmark',
      label: 'ENTREGA DE LOTES',
      color: '#FF6600',
      route: '/tvf/recebimento/entregar-lotes',
      flags: ['ORCV', 'OEL'],
    },
    {
      icon: 'collections_bookmark',
      label: 'CARREGAMENTO',
      color: '#003B71',
      route: '/tvf/recebimento/carregamento',
      flags: ['ORCV'],
    },
  ];

  constructor(private store: Store) {}

  receipt: boolean = false;
  ngOnInit(): void {
    const loggedUser = this.store.selectSnapshot(AuthState);

    this.buttonsTvf = this.allButtons.filter(
      (button) => this.hasAllPermissions(loggedUser?.attributes, button.flags)
    );

    this.receipt = this.buttonsTvf.length > 0;
  }

  private hasAllPermissions(attributes: any, flags: string[]): boolean {
    return flags.every((flag) => attributes?.[flag] === 'True');
  }
}
